import React, { useEffect, useState } from 'react'
import {
  Button,
  Grid,
  makeStyles,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Modal } from 'asterX-UI/Modals'
import { CASH, CASHLESS, CREDIT, STRAIGHT, TRADEIN } from 'constants/paperwork'
import useSeoApis from 'hooks/useSeoApis'
import { CarService, SalesService } from 'lib/api'
import { useResErrors } from 'hooks'
import CarData from 'components/Desktop/Car/CarData'
import CarSelectionCard from 'components/Desktop/Car/CarSelectionCard'
import CreateTaskComponent from 'components/Desktop/Tasks/CreateTaskComponent'
import AutoCompleteField from 'asterX-UI/Inputs/AutoCompleteField'
import { PAYMENT } from 'constants/deals'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import AsterTitleTypography from 'asterX-UI/Typography/AsterTitleTypography'
import QRCode from 'react-qr-code'
import { FileUploader } from 'components/Desktop/FileUploader'
import { ERROR_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import Check from '@material-ui/icons/Check'
import { Error } from '@material-ui/icons'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative'
  },
  buttonBar: {
    position: 'sticky',
    bottom: 5,
    width: '100%'
  },
  rootDiv: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    gap: 10
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10
  }
}))

const Paperwork = () => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()

  const {
    store: { selectedCarForSale, sale, loading, upSale },
    funcs: { sendToPaperWork, updateSale }
  } = useSelectionStore()

  const [open, setOpen] = useState({
    openTask: false,
    openQr: false,
    openCheck: false,
    openPv: false
  })

  const [checkFile, setCheckFile] = useState({
    check: '',
    pv: ''
  })

  const [saleType, setSaleType] = useState(null)
  const [paymentType, setPaymentType] = useState(null)
  const [hasTicket, setHasTicket] = useState(false)
  const { hasActiveTicket, closeTicket, seoLoading } = useSeoApis()
  const { standardCheck, silentCheck } = useResErrors()
  const [tradeInCar, setTradeInCar] = useState(null)
  const [inputedVin, setInputedVin] = useState(sale?.tradeInCarVin || '')
  const [selectedVin, setSelectedVin] = useState(sale?.tradeInCarVin || '')
  const [loadingCarList, setLoadingCarList] = useState(false)
  const [carList, setCarList] = useState([])

  useEffect(() => {
    hasActiveTicket({
      onSuccess: res => {
        setHasTicket(!!res?.ticketId)
      }
    })
  }, [])

  useEffect(() => {
    onSearchCar()
  }, [inputedVin])

  useEffect(() => {
    if (sale?.tradeInCarVin) {
      getCarByVin()
    }
  }, [sale?.tradeInCarVin])

  useEffect(() => {
    if (sale) {
      updateSale()
    }
    setCheckFile({
      ...checkFile,
      check: upSale?.billScan,
      pv: upSale?.initialPaymentApplicationScan
    })
  }, [upSale?.sppApprove])

  const menuItemsPayment = () => {
    const cash = {
      value: CASH,
      label: 'Наличные'
    }
    const credit = {
      value: CREDIT,
      label: 'Кредит'
    }
    const cashless = {
      value: CASHLESS,
      label: 'Безналичные'
    }
    if (CREDIT === saleType) {
      return [credit]
    } else if (STRAIGHT === saleType) {
      return [cash, cashless]
    } else {
      return [cash, cashless, credit]
    }
  }

  const getDemonstrationResults = () => {
    const car = selectedCarForSale
    if (car) {
      return {
        resultConfiguration: car?.resultConfiguration,
        resultExternal: car?.resultExternal,
        resultPrice: car?.resultPrice,
        resultTechnical: car?.resultTechnical,
        resultTestDrive: car?.resultTestDrive,
        resultTestDriveExpress: car?.resultTestDriveExpress,
        isNotDemonstrated: car?.isNotDemonstrated,
        comment: car?.comment
      }
    }
    return null
  }
  const onSearchCar = async () => {
    if (inputedVin.length < 3) {
      return setLoadingCarList(false)
    }
    setLoadingCarList(true)
    await CarService.getCarList(
      {
        vin: inputedVin,
        statusCodes: ['ppp', 'cp', 're_cp', 'available', 'reserved']
      },
      0,
      4
    ).then(res =>
      silentCheck(res, () => {
        setCarList(res.data.listCars)
      })
    )
    setLoadingCarList(false)
  }

  const getPaymentLink = branch => {
    switch (branch) {
      case 'ALA_BESAGASH':
        return 'https://pay.kaspi.kz/pay/ozxt0ksj'
      case 'ASTANA':
        return 'https://pay.kaspi.kz/pay/zwch14i8'
      case 'SHYMKENT':
        return 'https://pay.kaspi.kz/pay/h5sxwxml'
      case 'AKTOBE':
        return 'https://pay.kaspi.kz/pay/patrzwd1'
      default:
        return 'Ссылка не найдена'
    }
  }

  const handleUploadFile = (e, fileType) => {
    const files = e.target.files
    if (files) {
      if (files.length !== 0) {
        const file = files[0]
        SalesService.uploadFiles(file).then(res => {
          standardCheck(res, () => {
            switch (fileType) {
              case 'check':
                setCheckFile({ ...checkFile, check: res.data.fileDownloadUri })
                break
              case 'pv':
                setCheckFile({ ...checkFile, pv: res.data.fileDownloadUri })
                break
              default:
                break
            }
          })
        })
      }
    }
  }

  const onSave = async () => {
    let haveTicket = false
    await hasActiveTicket({
      onSuccess: res => {
        haveTicket = !!res?.ticketId
        setHasTicket(!!res?.ticketId)
      }
    })
    if (haveTicket) {
      return await closeTicket({
        onSuccess: res => {
          sendToPaperWork(saleType, paymentType)
        }
      })
    }
    sendToPaperWork(saleType, paymentType)
  }
  const onChangeSaleType = ({ target: { value } }) => {
    setSaleType(value)
    setPaymentType(null)
  }

  const getCarByVin = async () => {
    await CarService.getCarByVin(sale?.tradeInCarVin).then(response =>
      standardCheck(response, () => {
        setTradeInCar(response.data)
      })
    )
  }

  const handleChangeTradeIn = async vin => {
    setInputedVin(vin)
    setLoadingCarList(true)
  }

  const handleSelectTradeIn = e => {
    const { value } = e.target
    setInputedVin(value)
    setSelectedVin(value)
    updateSale({ tradeInCarVins: [value] })
  }

  const handleOpenTask = () => {
    if (upSale?.sppApprove && [null, ''].includes(checkFile?.check)) {
      enqueueSnackbar('Прикрепите чек перед отправкой на оформление', {
        variant: 'error'
      })
      return
    }
    setOpen({ ...open, openTask: true })
  }

  const sendCheck = type => {
    if (type === 'check') {
      updateSale({
        billScan: checkFile?.check
      })
      enqueueSnackbar('Чек прикреплен', {
        variant: 'success'
      })
      setOpen({ ...open, openCheck: false })
    }

    if (type === 'pv') {
      updateSale({
        initialPaymentApplicationScan: checkFile?.pv
      })
      enqueueSnackbar('ПВ прикреплен', {
        variant: 'success'
      })
      setOpen({ ...open, openPv: false })
    }
  }

  return (
    <div className={classes.container}>
      <LoaderBackdrop loading={loading || seoLoading} />
      <div className={classes.rootDiv}>
        <div className={classes.row}>
          <TextField
            select
            value={saleType}
            label={'Вид продажи'}
            onChange={onChangeSaleType}
            fullWidth
          >
            <MenuItem value={STRAIGHT}>{STRAIGHT}</MenuItem>
            <MenuItem value={CREDIT}>{CREDIT}</MenuItem>
            <MenuItem value={TRADEIN}>{TRADEIN}</MenuItem>
          </TextField>
          <TextField
            select
            label={'Вид оплаты'}
            value={paymentType}
            fullWidth
            disabled={!saleType}
            onChange={({ target: { value } }) => setPaymentType(value)}
          >
            {menuItemsPayment().map((item, indx) => (
              <MenuItem value={item.value} key={`paymentType_${indx}`}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>
          {saleType === TRADEIN && (
            <div
              style={{
                width: '100%'
              }}
            >
              <AutoCompleteField
                label={'VIN Trade-In'}
                fullWidth
                value={selectedVin}
                onInput={({ target: { value } }) => handleChangeTradeIn(value)}
                onChange={handleSelectTradeIn}
                loading={loadingCarList}
                options={carList}
                valueKey={'vin'}
                labelKey={'vin'}
                name={'markaNew'}
              />
            </div>
          )}
        </div>
        {selectedCarForSale && (
          <CarData
            vin={selectedCarForSale.vin}
            carForSale={selectedCarForSale}
            isSelected
            demonstrationResults={getDemonstrationResults()}
          />
        )}
        {tradeInCar && <CarSelectionCard car={tradeInCar} onClick={() => {}} />}
        {[false].includes(upSale?.sppApprove) && (
          <Grid item container display="flex">
            <Error style={{ color: `${ERROR_COLORS[500]}` }} />
            <Typography
              style={{
                marginLeft: 10,
                fontWeight: 500,
                fontSize: 16
              }}
            >
              Запрос в спп отказан
            </Typography>
          </Grid>
        )}

        {[true].includes(upSale?.sppApprove) && (
          <>
            <Grid item container display="flex">
              <Check style={{ color: `${SUCCESS_COLORS[500]}` }} />
              <Typography
                style={{
                  marginLeft: 10,
                  fontWeight: 500,
                  fontSize: 16
                }}
              >
                Запрос в спп согласован
              </Typography>
            </Grid>
            <Grid item container display="flex" spacing={2}>
              <Grid item xs={4} md={4}>
                <Button
                  variant={'outlined'}
                  color={'primary'}
                  fullWidth
                  onClick={() => setOpen({ ...open, openQr: true })}
                >
                  Открыть QR
                </Button>
              </Grid>
              <Grid item xs={4} md={4}>
                <Button
                  variant={'outlined'}
                  color={'primary'}
                  fullWidth
                  onClick={() => setOpen({ ...open, openCheck: true })}
                >
                  Прикрепить чек
                </Button>
              </Grid>
              <Grid item xs={4} md={4}>
                <Button
                  variant={'outlined'}
                  color={'primary'}
                  fullWidth
                  onClick={() => setOpen({ ...open, openPv: true })}
                >
                  Заявления для принятия ПВ.
                </Button>
              </Grid>
            </Grid>
          </>
        )}
        <div className={classes.buttonBar}>
          <Button
            variant={'contained'}
            color={'primary'}
            fullWidth
            onClick={handleOpenTask}
          >
            На оформление
          </Button>
        </div>
      </div>
      <Modal
        open={open.openTask}
        onClose={() => setOpen({ ...open, openTask: false })}
        fullWidth
      >
        <CreateTaskComponent
          saleId={sale?.id}
          globalId={sale?.globalId}
          isPayment={sale?.saleStatus?.code === PAYMENT}
          client={{
            contactFullname: `${sale?.client?.firstName || ''} ${
              sale?.client?.lastName || ''
            }`,
            phoneNumber: sale?.client?.phoneNumber || '',
            additionalPhoneNumber: sale?.client?.additionalPhoneNumber || ''
          }}
          onClose={() => setOpen({ ...open, openTask: false })}
          onSuccess={onSave}
        />
      </Modal>
      <ActionModal
        open={open.openQr}
        onClose={() => setOpen({ ...open, openQr: false })}
        title="QR code"
      >
        <Grid
          item
          container
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ marginBottom: 30 }}
        >
          <AsterTitleTypography
            label={'Просканируйте QR code'}
            style={{ marginBottom: 5 }}
          />
          <QRCode
            value={getPaymentLink(
              upSale?.selectedCarsForSale[0]?.cpBranch?.code
            )}
            title={'Выдача'}
            size={256}
          />
        </Grid>
      </ActionModal>
      <ActionModal
        open={open.openCheck}
        onClose={() => setOpen({ ...open, openCheck: false })}
        onCancel={() => setOpen({ ...open, openCheck: false })}
        onConfirm={() => sendCheck('check')}
        title="Прикрепить чек"
      >
        <FileUploader
          uploadedFile={checkFile?.check}
          setUploadedFile={file => setCheckFile({ ...checkFile, check: file })}
          onChange={e => handleUploadFile(e, 'check')}
          placeholder={'Прикрепите чек'}
          downloadedPlaceholder={'Чек загружен'}
        />
      </ActionModal>
      <ActionModal
        open={open.openPv}
        onClose={() => setOpen({ ...open, openPv: false })}
        onCancel={() => setOpen({ ...open, openPv: false })}
        onConfirm={() => sendCheck('pv')}
        title="Прикрепить заявление"
      >
        <Typography style={{ marginBottom: 5 }}>
          Заявление по учету денежных средств для резерва авто, загружается
          только в случае взноса денежных средств 3 лицом
        </Typography>
        <FileUploader
          uploadedFile={checkFile?.pv}
          setUploadedFile={file => setCheckFile({ ...checkFile, pv: file })}
          onChange={e => handleUploadFile(e, 'pv')}
          placeholder={'Прикрепить заявление'}
          downloadedPlaceholder={'документ загружен'}
        />
      </ActionModal>
    </div>
  )
}
export default Paperwork
